import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Warning.svg",
  "use": "Warning.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Warning.svg\">\n<path d=\"M55.0064,52.0079H9.0234a3.0009,3.0009,0,0,1-2.5655-4.5547L29.4494,9.4424a2.9977,2.9977,0,0,1,5.1309,0L57.5719,47.4532A3.0009,3.0009,0,0,1,55.0064,52.0079ZM32.0148,48.0207a3,3,0,1,0-3-3A3,3,0,0,0,32.0148,48.0207Zm1.9985-28H30.0344a1.01,1.01,0,0,0-1.0209,1.0526l.9147,17a1.0127,1.0127,0,0,0,1.021.9474h2.1493a1.013,1.013,0,0,0,1.0211-.9474l.9147-17A1.01,1.01,0,0,0,34.0133,20.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol